import { defineMessages } from 'react-intl';

export const legalHintsCardMessages = defineMessages({
  legalHintsCardHeader: {
    id: 'legalHintsCardHeader.header',
    defaultMessage: 'Rechtliche Hinweise',
  },
});
